<div *ngIf="user" class="extra-space">
  <p class="title">{{user?.firstName + ' ' + user?.lastName}}</p>
  <div class="d-flex mt-2 mb-3">
    <div class="tier-badge">
      <ng-container [ngSwitch]="user?.verificationDetails?.tier">
        <ng-container *ngSwitchCase="TierLevel.TIER_1" i18n="@user.menu.verified.TIER_1">TIER 1</ng-container>
        <ng-container *ngSwitchCase="TierLevel.TIER_2" i18n="@user.menu.verified.TIER_2">TIER 2</ng-container>
        <ng-container *ngSwitchCase="TierLevel.TIER_3" i18n="@user.menu.verified.TIER_3">TIER 3</ng-container>
        <ng-container *ngSwitchDefault i18n="@user.menu.verified.none">Not verified</ng-container>
      </ng-container>
    </div>
    <div class="me-1"></div>
    <div class="vip-badge" *ngIf="user?.vip" i18n="@@user.icon.vip">VIP</div>
  </div>
</div>

<div *ngIf="!user">
  <menu-item
    titleItem="Log in"
    i18n-titleItem="@@mobileMenu.login"
    link="/login"
    icon="icon-i-signin"
  ></menu-item>
  <menu-item
    titleItem="Register"
    i18n-titleItem="@@mobileMenu.register"
    icon="icon-i-create-account"
    link="/register"
  ></menu-item>
  <div class="m-2 line"><br/></div>
</div>
